import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connectModal } from 'redux-modal';
import BMXButton from '../../../../Components/Buttons/BMXButton/BMXButton';
import BMXModal from '../../../../Components/Modals/BMXModal/BMXModal';
import GlobalAlertForm from '../../Forms/GlobalAlertForm/GlobalAlertForm';

const GlobalAlertModal = (props) => {

  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t('global:alert.globalAlert'), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "GlobalAlertForm";
  const { handleHide, show } = props;
  

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          bmxclass="Success"
          onClick={() => setIsSubmit(true)}
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={'800px'}
      height={'600px'}
      onClose={handleHide}
      buttons={buttons()}
      steps={steps}
      header={t('global:alert.addAlert')}
      >
       <GlobalAlertForm  
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        formName={formName}
        handleHide={handleHide}
        setErrorHeader={setErrorHeader}
        {...props} />
    </BMXModal>
  );
};

export default connectModal({ name: 'GlobalAlertModal' })(GlobalAlertModal);
